import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Tpl3plService, LogEntry } from '../../../services/tpl3pl.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { LogErrorDetailsModalComponent } from './log-error-details-modal/log-error-details-modal.component';
import { LogRequestResponseModalComponent } from './log-request-response-modal/log-request-response-modal.component';

@Component({
	selector: 'app-tpl3pl-logs',
	templateUrl: './tpl3pl-logs.component.html',
	styleUrls: ['./tpl3pl-logs.component.scss']
})
export class Tpl3plLogsComponent implements OnInit, AfterViewInit {
	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;

	displayedColumns: string[] = ['created_at', 'log_type', 'orderno', 'direction', 'status', 'message', 'error_details', 'actions'];
	dataSource = new MatTableDataSource<LogEntry>();
	loading = false;
	logTypeFilter = '';
	statusFilter = '';
	ordernoFilter = '';

	constructor(
		private tpl3plService: Tpl3plService,
		private globalSearchService: GlobalSearchService,
		private route: ActivatedRoute,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.route.queryParamMap.subscribe(params => {
			const orderFromRoute = params.get('orderno');
			if (orderFromRoute !== null) {
				this.ordernoFilter = orderFromRoute;
			}
			this.loadLogs();
		});
	}

	ngAfterViewInit(): void {
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}

	loadLogs(): void {
		this.loading = true;
		const filters: any = { limit: 100, offset: 0 };
		if (this.logTypeFilter) {
			filters.log_type = this.logTypeFilter;
		}
		if (this.statusFilter) {
			filters.status = this.statusFilter;
		}
		if (this.ordernoFilter) {
			filters.orderno = this.ordernoFilter;
		}

		this.tpl3plService.getLogsPost(filters).subscribe({
			next: (result) => {
				this.dataSource.data = result.data;
				this.loading = false;
			},
			error: (error) => {
				this.globalSearchService.showNotification('Error loading logs', 'danger', 'bottom', 'right');
				this.loading = false;
			}
		});
	}

	getStatusIcon(status: string): string {
		switch (status) {
		case 'success': return 'check_circle';
		case 'error': return 'error';
		case 'warning': return 'warning';
		default: return 'info';
		}
	}

	getStatusColor(status: string): string {
		switch (status) {
		case 'success': return 'text-success';
		case 'error': return 'text-danger';
		case 'warning': return 'text-warning';
		default: return 'text-muted';
		}
	}

	applyFilter(event: Event): void {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}

	showErrorDetails(item: LogEntry): void {
		if (!item.error_details) { return; }
		this.dialog.open(LogErrorDetailsModalComponent, {
			width: '90vw',
			maxWidth: '720px',
			maxHeight: '90vh',
			data: {
				error_details: item.error_details,
				message: item.message,
				orderno: item.orderno,
				created_at: item.created_at
			}
		});
	}

	getStatusLabel(status: string): string {
		switch (status) {
		case 'success': return 'Success';
		case 'error': return 'Error';
		case 'warning': return 'Warning';
		default: return status || 'Info';
		}
	}

	showRequestResponse(item: LogEntry): void {
		if (item.request_data == null && item.response_data == null) { return; }
		this.dialog.open(LogRequestResponseModalComponent, {
			width: '700px',
			maxHeight: '90vh',
			data: {
				request_data: item.request_data,
				response_data: item.response_data,
				orderno: item.orderno,
				created_at: item.created_at,
				message: item.message
			}
		});
	}
}
